<template>
    <div id="Statistical_Into">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>用户统计</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row :gutter="20" class="display">
            <el-col :span="6">
                <div class="order-head" style="background: #2c8fed">
                    <div class="head-top">
                        <h5>今日新增</h5>
                        <p>{{today.join_person}}人</p>
                    </div>
                    <div class="head-bottom">
                        <div class="head-bottom-item">
                            <h5>
                                <span>{{today.male}}人</span>
                                <span class="sex"> 男性,</span>
                                <span>{{today.female}}人</span>
                                <span class="sex"> 女性,</span>
                                <span>{{today.secretmale}}人</span>
                                <span class="sex"> 未知</span>
                            </h5>
                            <p>已付费: <span> {{today.pay_person}}人 ({{today.join_person_pay_rate}}%)</span></p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="order-head" style="background: #2BCF43">
                    <div class="head-top">
                        <h5>昨日新增</h5>
                        <p>{{yesterday.join_person}}人</p>
                    </div>
                    <div class="head-bottom">
                        <div class="head-bottom-item">
                            <h5>
                                <span>{{yesterday.male}}人</span>
                                <span class="sex"> 男性,</span>
                                <span>{{yesterday.female}}人</span>
                                <span class="sex"> 女性,</span>
                                <span>{{yesterday.secretmale}}人</span>
                                <span class="sex"> 未知</span>
                            </h5>
                            <p>已付费: <span> {{yesterday.pay_person}}人 ({{yesterday.join_person_pay_rate}}%)</span></p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="order-head" style="background: #F5CB4E">
                    <div class="head-top">
                        <h5>本月新增 (包含当日) </h5>
                        <p>{{month.join_person}}人</p>
                    </div>
                    <div class="head-bottom">
                        <div class="head-bottom-item">
                            <h5>
                                <span>{{month.male}}人</span>
                                <span class="sex"> 男性,</span>
                                <span>{{month.female}}人</span>
                                <span class="sex"> 女性,</span>
                                <span>{{month.secretmale}}人</span>
                                <span class="sex"> 未知</span>
                            </h5>
                            <p>已付费: <span> {{month.pay_person}}人 ({{month.join_person_pay_rate}}%)</span></p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="order-head" style="background: #fa5a4c">
                    <div class="head-top">
                        <h5>所有时间</h5>
                        <p>{{total.join_person}}人</p>
                    </div>
                    <div class="head-bottom">
                        <div class="head-bottom-item">
                            <h5>
                                <span>{{total.male}}人</span>
                                <span class="sex"> 男性,</span>
                                <span>{{total.female}}人</span>
                                <span class="sex"> 女性,</span>
                                <span>{{total.secretmale}}人</span>
                                <span class="sex"> 未知</span>
                            </h5>
                            <p>已付费: <span> {{total.pay_person}}人 ({{total.join_person_pay_rate}}%)</span></p>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-card class="box-card">
            <el-form ref="form" :model="form" label-width="80px" :inline="true" size="small">
                <el-form-item label="">
                    <el-col :span="11">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="开始日期" v-model="form.time1"
                                            value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1">-</el-col>
                    <el-col :span="11">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="结束日期" v-model="form.time2"
                                            value-format="yyyy-MM-dd" style="width: 100%;"
                                            @change="changeClick"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="date"
                        label="日期">
                </el-table-column>
                <el-table-column
                        prop="join_person"
                        label="新增用户">
                </el-table-column>
                <el-table-column
                        prop="pay_person"
                        label="已付费">
                </el-table-column>
                <el-table-column
                        prop="male"
                        label="	男性">
                </el-table-column>
                <el-table-column
                        prop="female"
                        label="女性">
                </el-table-column>
            </el-table>
            <div class="el-pagination">
                <el-pagination
                        background
                        @size-change="changeSize"
                        @current-change="changeCurrent"
                        :current-page="params.pagenum"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="params.pagesize"
                        :layout="this.$store.state.paginationLayout"
                        :total="params.totals">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "Statistical_Into",
        data() {
            return {
                params: {
                    pagenum: 1,
                    pagesize: 10,
                    totals: 0,
                },
                form: {
                    time1: '',
                    time2: ''
                },
                tableData: [],
                fromTitle: '',
                visible: false,
                imageUrl: '',
                activeName: 'first',
                today: '',
                yesterday: '',
                month: '',
                total: '',
            }
        },
        created() {
            this.getList()
        },
        methods: {
            changeClick(e) {
                console.log(e)
                if (e < this.form.time1) {
                    this.$message.error('结束日期不能小于开始日期');
                    this.form.time2 = '';
                }
            },
            getList() {
                let data = {
                    page: this.params.pagenum,
                    page_size: this.params.pagesize,
                    start_time: this.form.time1,
                    end_time: this.form.time2
                };
                console.log(data.end_time);
                this.$axios.post("mch/user/base_info", data).then((res) => {
                    this.params.totals = res.data.date_datas_count;
                    this.tableData = res.data.date_datas;
                    this.today = res.data.today;
                    this.yesterday = res.data.yesterday;
                    this.month = res.data.month
                    this.total = res.data.total;
                });
            },
            // 每页显示多少条
            changeSize(val) {
                this.params.pagesize = val;
                this.getList();
            },
            // 当前显示的页数
            changeCurrent(val) {
                this.params.pagenum = val;
                this.getList();
            },
            search() {
                this.params.pagenum = 1;
                this.getList();
            }

        }
    }
</script>

<style scoped>
    @media screen and (max-width: 750px) {
        .display {
            display: flex;
            flex-wrap: wrap;
        }

        .display .el-col-6 {
            width: 100%;
        }
    }

    .order-head {
        height: 160px;
        background: #f5f5f5;
        margin-top: 20px;
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;
        font-size: 14px;
        color: #f2f2f2;
    }

    .order-head .head-top h5 {
        font-weight: 700;
    }

    .order-head .head-top p {
        color: #ffffff;
        font-size: 32px;
        padding: 10px 0;
    }

    .order-head .head-bottom {
        display: flex;
    }

    .order-head .head-bottom .head-bottom-item {
        flex: 1;
    }

    .order-head .head-bottom .head-bottom-item h5 {
        font-weight: 700;
        line-height: 25px;
    }

    .order-head .head-bottom .head-bottom-item p {
        line-height: 25px;
    }

    .order-head .head-bottom .head-bottom-item span {
        line-height: 25px;
        /*color: #8a6d3b;*/
        font-weight: 700;
        color: #dff0d8;
    }

    .order-head .head-bottom .head-bottom-item .sex {
        font-weight: 500;
        /*color: #777777;*/
    }

</style>